import template from "./pCasemanSync.html";

import moment from "moment";

export function pCasemanSyncDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanSyncController,
    controllerAs: 'pCasemanSync',
    bindToController: true
  };

  return directive;
}

class pCasemanSyncController {
  constructor($scope, $interval, $filter, $translate, Auth, Caseman, Notes, Statistics, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$interval = $interval;
    this.$filter = $filter;
    this.$translate = $translate;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Statistics = Statistics;
    this.ConnectionQuality = ConnectionQuality;
    this.allAggregatesChecked = false;
    this.more = {
      column: false,
      invoiceDetails: false
    };
    this.showStatsInfo = false;
    this.showModal = false;
    this.worklogsDetailsForAggregate = [];
    this.hasErpProjectsFlag = false;
    this.statusFail = false;
    this.statusDone = false;
    this.syncReportsLanguage = 'en';

    // sessionStorage.setItem("roedl-sync-date-start", this.dateStartChoice);
    // sessionStorage.setItem("roedl-sync-date-end", this.dateEndChoice);
    this.dateStartChoice = sessionStorage.getItem("roedl-sync-date-start") || moment().subtract(7,'d').format("YYYY-MM-DD");
    this.dateEndChoice = sessionStorage.getItem("roedl-sync-date-end") || moment().format("YYYY-MM-DD");

    this.headers = [
      {name: "CASEMAN_SYNC.CHECK", class: "table-check2"},
      {name: "CASEMAN_SYNC.DATE", class: null},
      {name: "CASEMAN_SYNC.CLIENT", class: null},
      {name: "CASEMAN_SYNC.PROJECT", class: null},
      {name: "CASEMAN_SYNC.JOBCODE", class: null},
      {name: "CASEMAN_SYNC.SUBCODE", class: null},
      {name: "CASEMAN_SYNC.PAID", class: "table-check"},
      {name: "CASEMAN_SYNC.COMMENT", class: null},
      {name: "CASEMAN_SYNC.INVOICE_DETAILS", class: null},
      {name: "CASEMAN_SYNC.DURATION", class: null},
      {name: "CASEMAN_SYNC.COUNTRY", class: null},
      {name: "CASEMAN_SYNC.STATUS", class: "table-status"},
      {name: "CASEMAN_SYNC.PROBLEM", class: "table-problem"},
    ];

    this.modalHeaders = [
      {name: "STATS.CLIENT_NAME", class: "table-info"},
      {id: "projectName", name: "CASEMAN_SYNC.PROJECT", class: "table-info"},
      {name: "PROCESS_GROUP", class: "table-info table-pg"},
      {name: "PROCESS", class: "table-info"},
      {name: "WORK_DATA.START_DATE", class: "table-date"},
      {name: "WORK_DATA.START_TIME", class: "table-time"},
      {name: "WORK_DATA.DURATION", class: "table-time"},
      {name: "WORK_DATA.VA", class: "table-short"},
      {name: "WORK_DATA.VOLUME", class: "table-number"},
      {name: "WORK_DATA.ADDED_MANUALLY", class: "table-short"},
      {name: "WORK_DATA.COMMENT", class: "table-commentHeader"},
      {name: "WORK_DATA.INVOICE_DETAILS", class: "table-commentHeader"},
    ];

    this.modalHeadersErpFlag = this.modalHeaders.filter(header => header.id !== "projectName");

    this.state = "loading";
    this.init();

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  autosync() {
    this.state = "loading";
    const data = {enableAutoSync: this.autoSyncMode.checked};

    if (!data.enableAutoSync) {
      this.sendSyncReports = false;
      data.sendSyncReports = false;
    }
    
    this.Caseman.updateUserSyncSettings(data).then(
      () => {
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  sendReportsHandler() {
    this.state = "loading";
    this.Caseman.updateUserSyncSettings({sendSyncReports: this.sendSyncReports}).then(
      () => {
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.sendSyncReports = !this.sendSyncReports;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  chooseReportLanguage() {
    this.state = "loading";
    this.Caseman.updateUserSyncSettings({syncReportsLanguage: this.syncReportsLanguage, sendSyncReports: this.sendSyncReports}).then(
      () => {
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.syncReportsLanguage = !this.syncReportsLanguage;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  changeAggregationType() {
    this.state = "loading";
    this.Caseman.updateUserSyncSettings({aggregateType: this.aggregateType}).then(
      () => {
        this.init();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  showMore(aggregate, column) {
    aggregate.showMore[column] = !aggregate.showMore[column];
    return this.more[column] = !this.more[column];
  }

  updateStartDate() {
    this.state = "loading";
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    if(this.dateEnd.unix() < this.dateStart.unix()) {
      this.dateEnd = this.dateStart;
      this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");
    }
    sessionStorage.setItem("roedl-sync-date-start", this.dateStartChoice);
    sessionStorage.setItem("roedl-sync-date-end", this.dateEndChoice);
    this.init();
  }

  updateEndDate() {
    this.state = "loading";
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    if(this.dateEnd.unix() < this.dateStart.unix()) {
      this.dateStart = this.dateEnd;
      this.dateStartChoice = this.dateEnd.format("YYYY-MM-DD");
    }
    sessionStorage.setItem("roedl-sync-date-start", this.dateStartChoice);
    sessionStorage.setItem("roedl-sync-date-end", this.dateEndChoice);
    this.init();
  }

  init() {
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.hasErpProjectsFlag = !!user.preferences.featureFlags.find(ff => ff === "ProjectsFromErpSystem");

        //Notes...
        const timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.Caseman.getUserSyncSettings(this.user.id).then((success) => {
          this.autoSyncMode = {
            checked: angular.copy(success.data.enableAutoSync)
          };
          this.sendSyncReports = success.data.sendSyncReports;
          this.aggregateType = angular.copy(success.data.aggregateType);
          this.syncReportsLanguage = success.data.syncReportsLanguage;
        }).catch((error) => {
          this.state = "error";
          this.Notes.postNote({type: "error", error: error});
        });

        this.Caseman.getAggregates(this.dateStartChoice, this.dateEndChoice).then(
          (succ) => {
            this.aggregatesToDisplay = succ.data.map( aggregate => {
              aggregate.showMore = {
                comment: false,
                invoiceDetails: false
              };
              aggregate.comment = aggregate.description;

              if(aggregate.casemanStatus && aggregate.casemanStatus != "Success") {
                aggregate.statusInfo = aggregate.casemanStatus;
              } else if(aggregate.syncStatus) {
                aggregate.statusInfo = aggregate.syncStatus;
              }

              if (aggregate.additionalInfo)
                aggregate.nameWithAdditionalInfo = `(${aggregate.additionalInfo}) ${aggregate.clientName}`;

              return aggregate;
            } );

            this.statsWidth = this.Statistics.getStatsWeight(this.aggregatesToDisplay);

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  checkAll() {
    this.allAggregatesChecked = !this.allAggregatesChecked;

    this.aggregatesToDisplay.forEach( agg => {
      if(this.allAggregatesChecked && agg.casemanStatus != "Success")
        agg.checked = true;
      else
        agg.checked = false;
    });

    if( this.aggregatesToDisplay.find( agg => agg.checked == true) )
      this.anyAggregatesChecked = true;
    else
      this.anyAggregatesChecked = false;
  }

  checkIfAll() {
    if( this.aggregatesToDisplay.filter( agg => agg.checked == true ).length == this.aggregatesToDisplay.length )
      this.allAggregatesChecked = true;
    else
      this.allAggregatesChecked = false;

    if( this.aggregatesToDisplay.find( agg => agg.checked == true) )
      this.anyAggregatesChecked = true;
    else
      this.anyAggregatesChecked = false;
  }

  doSync(){
    this.state = "loading";
    this.aggregatesToSend =  this.aggregatesToDisplay.filter( (aggregate) => aggregate.checked ).map( x => {
      return x.worklogEntryIds;
    });

    this.Caseman.sendAggregates(this.aggregatesToSend).then(
      (success) => {
        if(success.data == "Caseman is dead.") {
          this.Notes.postNote({type: "dead", error: success.data});
          this.state = "error";
        }else{
          this.init();
        }
       },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  formatDateInWorklogResponseWay(date) {
    return date.format("YYYY-MM-DD") + "T" + date.format("HH:mm:ss.SSS");
  }

  showWorklogsDetails(aggregate) {
    this.state = "loading";

    const idsArray = aggregate.worklogEntryIds;

    this.Caseman.getWorklogsForAggregate(idsArray).then(
      (success) => {
        this.worklogsDetailsForAggregate = success.data.map(d => {
          return ({
            ...d,
            date: aggregate.date,
            aggregateClientName: aggregate.clientName,
            projectName: aggregate.projectName,
            duration: moment.duration(d.duration),
            startedAt: this.formatDateInWorklogResponseWay(moment.utc(d.startedAt).local()),
            nameWithAdditionalInfo: aggregate.nameWithAdditionalInfo
          });
        });

        const durationSum = this.worklogsDetailsForAggregate.reduce((accum, curr) => curr.duration.clone().add(accum), moment.duration(0));
        this.durationSumText = this.$filter("hms")(durationSum.toJSON());
        this.state = "loaded";
        this.showModal = true;
        angular.element(document.body).addClass("modalOpen");
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  closeModal() {
    this.showModal = false;
    this.worklogsDetailsForAggregate = [];
    angular.element(document.body).removeClass("modalOpen");
  }

  filterAggregates(statusDone, statusFail) {
    return function(value) {
      if (
        (!statusDone && !statusFail)
        || (statusDone && value.casemanStatus === 'Success')
        || (statusFail && value.casemanStatus && value.casemanStatus !== 'Success')
      ) {
        return value;
      }
    };
  }
}
